var __runtime = {"escape":function (input) {
    var htmlRegex = /["&<>]/
    var regexResult = htmlRegex.exec(input)
    if (!regexResult) { return input }

    var result = ''
    var i, lastIndex, escape
    for (i = regexResult.index, lastIndex = 0; i < input.length; i++) {
      switch (input.charCodeAt(i)) {
        case 34: escape = '&quot;'; break
        case 38: escape = '&amp;'; break
        case 60: escape = '&lt;'; break
        case 62: escape = '&gt;'; break
        default: continue
      }
      if (lastIndex !== i) { result += input.substring(lastIndex, i) }
      lastIndex = i + 1
      result += escape
    }
    return (lastIndex !== i ? result + input.substring(lastIndex, i) : result)
  }}; module.exports = (function (locals) { var res;;var locals_for_with = (locals || {});(function (contentful, page, pageCollection) {res = "" + ((function () { var res = []; var expr = (pageCollection(contentful.press, 2)[page]); for (var key in expr) { var item = expr[key]; res.push("\n  <div class=\"row col-sm-12 press-index-item\">\n    <a href=\"/press/" + (__runtime.escape(item.fields.slug)) + "?region=sg\" class=\"press-index-item-title\"> " + (__runtime.escape(item.fields.title)) + "</a>\n    <p class=\"press-index-item-body\">" + (__runtime.escape(item.fields.body)) + "</p>\n  </div>\n") } return res.join('') })()) + ""}.call(this,"contentful" in locals_for_with?locals_for_with.contentful:typeof contentful!=="undefined"?contentful:undefined,"page" in locals_for_with?locals_for_with.page:typeof page!=="undefined"?page:undefined,"pageCollection" in locals_for_with?locals_for_with.pageCollection:typeof pageCollection!=="undefined"?pageCollection:undefined));;return res })


//////////////////
// WEBPACK FOOTER
// ./views/sg/templates/_pressItem.html
// module id = 172
// module chunks = 0